import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class AccountElementService {

  constructor(private http: HttpClient) { }

  getElements() {
    return this.http.get<any>(Library.API_ENDPOINT + 'element/get_element_list', OPTIONS);
  }

  createUpdateElement(elementForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `element/save_update_element`, elementForm, OPTIONS);
  }

  getElementType() {
    return this.http.get<any>(Library.API_ENDPOINT + 'element/get_element_type', OPTIONS);
  }

  getTree() {
    return this.http.get<any>(Library.API_ENDPOINT + 'element/get_tree', OPTIONS);
  }

  deleteElement(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `element/delete_element/${id}`, OPTIONS);
  }

  getAccountType() {
    return this.http.get<any>(Library.API_ENDPOINT + 'element/get_account_type', OPTIONS);
  }

  getAccountSign() {
    return this.http.get<any>(Library.API_ENDPOINT + 'element/get_account_sign', OPTIONS);
  }

  createUpdateElementValue(elementForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `element/save_update_element_value`, elementForm, OPTIONS);
  }

  deleteElementValue(selectedIds: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `element/delete_element_value`, selectedIds, OPTIONS);
  }
}
